<script>
import KolonneSettingsAssignedEmployee from "./KolonneSettingsAssignedEmployee.vue";

export default {
  name: "KolonneSettingsEmployeesListItem",

  props: {
    active: {
      type: Boolean,
      default: false
    },
    employee: {
      type: Object | null,
      default: null
    },
    selectedKolonneId: {
      type: Number | String,
      default: ''
    },
    startdate: {
      type: String, // format "YYYY-MM-DD"
      default: '',
    },
    kolonneContent: {
      type: Array,
      default: () => [],
    },
    hideRanking: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    KolonneSettingsAssignedEmployee,
  },

  data () {
    return {
      isActive: this.active,
    };
  },

  computed: {
    ranking () {
      if (this.isAssignedInOtherWeek) {
        return 'red';
      }

      if (this.isNotAvailableInWeek) {
        return 'yellow';
      }

      return 'green';
    },

    isAssignedInOtherWeek () {
      return this.kolonnenNumbersOfOtherWeekAssignments.length > 0;
    },

    kolonnenNumbersOfOtherWeekAssignments () {
      return this.kolonneContent
        .filter(content => content.id !== this.selectedKolonneId)
        .filter(content => [].concat(content.employees_ids ?? []).includes(this.employee.id))
        .map(content => content.kolonne);
    },

    isNotAvailableInWeek () {
      return this.unavailabilitiesInWeek.length > 0
    },

    unavailabilitiesInWeek () {
      const startdate = new Date(this.startdate);
      const enddate = this.$moment(this.startdate).add(1, "Week").toDate();

      return this.employee.unavailabilities.filter(unavailability => {
        const date = new Date(unavailability.date.date)

        return date > startdate && date < enddate
      })
    },
  },

  watch: {
    active(newVal) {
      this.isActive = newVal
    },
  },

  methods: {
    onActiveChange() {
      this.$emit('activeChanged', this.employee.id, this.isActive)
    }
  },
};
</script>

<template>
  <div class="cell small-6">
    <label>
      <input
        type="checkbox"
        v-model="isActive"
        class="u-no-margin--bottom"
        @change="onActiveChange"
        />
      <i></i>

      <span
        v-if="!hideRanking"
        :title="kolonnenNumbersOfOtherWeekAssignments.join(', ')"
        :class="'c-ranking c-ranking--' + (ranking || 'none') ">
      </span>

      <span class="u-text-transform-none">
        {{ employee.lastName }}, {{ employee.firstName }}
      </span>
      
      <small
        class="u-text-transform-none"
        v-for="(qualification, index) in this.employee.qualifications"
        :key="index"
        >  <span v-if="index > 0">, </span> {{ qualification.name }}</small>
      <p
        v-if="!hideRanking && kolonnenNumbersOfOtherWeekAssignments.length"
        class="u-no-margin u-text-medium u-text-normal u-text-transform-none"
      >
        {{ $t('kolonne.label.assigned.to.other.kolonnen') }} {{ kolonnenNumbersOfOtherWeekAssignments.join(', ') }}
      </p>
    </label>
  </div>
</template>

